import { createApi } from "@reduxjs/toolkit/query/react";
import { ProfileInterestModalType } from "src/old/Types/ProfileEditType";
import baseQueryWithReAuth from "../../services/utils.service/baseQueryWithReAuth";
import {
	RequestResponse,
	RequestResponseInterest,
	ServerResponse,
} from "./types/types";

export const profileInterestApi = createApi({
	baseQuery: baseQueryWithReAuth,
	reducerPath: "profileInterestApi",
	endpoints: (builder) => ({
		//////////////////////////////////////////////GET
		getProfileInterest: builder.query<
			RequestResponseInterest,
			{ page?: number; limit?: number; name?: string }
		>({
			query: ({ page = 1, limit = 10, name }) => {
				const params = new URLSearchParams();
				if (name) params.append("search[name]", name);
				params.append("pagination[limit]", String(limit));
				params.append("pagination[page]", String(page));
				return `/prof-interests?${params.toString()}`;
			},
			transformResponse: (
				response: ServerResponse
			): RequestResponseInterest => {
				//console.log("getProfileInterest server otvet", response);
				return {
					data: Array.isArray(response.data) ? response.data : [],
					isErr: undefined,
				};
			},
		}),
		/////////////////////////////////////////////////////POST
		postProfileInterest: builder.mutation<
			{ token: string },
			ProfileInterestModalType
		>({
			query: (data) => {
				const userId = localStorage.getItem("userId") || "";
				if (!userId) {
					throw new Error("User ID is not found in localStorage");
				}

				const payload = {
					profInterestIds: data.profInterestIds,
				};

				//console.log("payloadInterest:", payload);

				return {
					url: `/v2/user/${userId}/profile/interest`,
					method: "PUT",
					body: JSON.stringify(payload),
					headers: {
						"Content-Type": "application/json",
					},
				};
			},
			transformResponse: (response: { data: { token: string } }) =>
				response.data,
		}),
	}),
});

export const {
	useLazyGetProfileInterestQuery,
	usePostProfileInterestMutation,
} = profileInterestApi;
